import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar/Navbar';
import Hero from './components/Hero/Hero';
import ClientsCarousel from './components/ClientsCarousel/ClientsCarousel';
import Benefits from './components/Benefits/Benefits';
import HowItWorks from './components/HowItWorks/HowItWorks';
import Pricing from './components/Pricing/Pricing';
import FAQ from './components/FAQ/FAQ';
import Testimonials from './components/Testimonials/Testimonials';
import CTA from './components/CTA/CTA';
import BlogSection from './components/BlogSection/BlogSection';
import Features from './pages/Features/Features';
import SoftwareForDistributorsLanding from './pages/Campaigns/SoftwareForDistributors/SoftwareForDistributorsLanding';
import FinancialControlLanding from './pages/Campaigns/FinancialControl/FinancialControlLanding';
import StockControlLanding from './pages/Campaigns/StockControl/StockControlLanding';
import WebinarDreLanding from './pages/Campaigns/WebinarDre/WebinarDreLanding';
import ServiceOrderLanding from './pages/Campaigns/ServiceOrder/ServiceOrderLanding';
import PDVLanding from './pages/Campaigns/PDV/PDVLanding';
import PurchaseControlLanding from './pages/Campaigns/PurchaseControl/PurchaseControlLanding';
import SalesManagementLanding from './pages/Campaigns/SalesManagement/SalesManagementLanding';
import SellerCommissionLanding from './pages/Campaigns/SellerCommission/SellerCommissionLanding';
import ProposalsLanding from './pages/Campaigns/Proposals/ProposalsLanding';
import PublicCatalogLanding from './pages/Campaigns/PublicCatalog/PublicCatalogLanding';
import CustomerPortalLanding from './pages/Campaigns/CustomerPortal/CustomerPortalLanding';
import NFeIssuerLanding from './pages/Campaigns/NFeIssuer/NFeIssuerLanding';
import NFSeIssuerLanding from './pages/Campaigns/NFSeIssuer/NFSeIssuerLanding';
import AutomaticBillingLanding from './pages/Campaigns/AutomaticBilling/AutomaticBillingLanding';
import CashFlowLanding from './pages/Campaigns/CashFlow/CashFlowLanding';
import VehicleFleetLanding from './pages/Campaigns/VehicleFleet/VehicleFleetLanding';
import EquipmentMaintenanceLanding from './pages/Campaigns/EquipmentMaintenance/EquipmentMaintenanceLanding';
import ContractManagementLanding from './pages/Campaigns/ContractManagement/ContractManagementLanding';
import MechanicWorkshopLanding from './pages/Campaigns/MechanicWorkshop/MechanicWorkshopLanding';
import ServiceProvidersLanding from './pages/Campaigns/ServiceProviders/ServiceProvidersLanding';
import ConstructionLanding from './pages/Campaigns/Construction/ConstructionLanding';
import TransportationLanding from './pages/Campaigns/Transportation/TransportationLanding';
import EquipmentRentalLanding from './pages/Campaigns/EquipmentRental/EquipmentRentalLanding';
import TechnicalAssistanceLanding from './pages/Campaigns/TechnicalAssistance/TechnicalAssistanceLanding';
import SalesRepLanding from './pages/Campaigns/SalesRep/SalesRepLanding';
import MultiCompanyLanding from './pages/Campaigns/MultiCompany/MultiCompanyLanding';
import SalesForceLanding from './pages/Campaigns/SalesForce/SalesForceLanding';
import RetailStoreLanding from './pages/Campaigns/RetailStore/RetailStoreLanding';
import CustomERPLanding from './pages/Campaigns/CustomERP/CustomERPLanding';
import Descadastro from './pages/Descadastro/Descadastro';
import Gravacao from './pages/Gravacao/Gravacao';
import Diagnostico from './pages/Diagnostico/Diagnostico';
import ScrollToHashElement from './components/ScrollToHashElement';
import Footer from './components/Footer/Footer';
import './App.scss';

const HomePage: React.FC = () => (
  <>
    <Hero />
    <ClientsCarousel />
    <Benefits />
    <HowItWorks />
    <Pricing />
    <Testimonials />
    <FAQ />
    <BlogSection />
    <CTA />
  </>
);

const App: React.FC = () => {
  return (
    <div className="App">
      <Navbar />
      <ScrollToHashElement />
      <main className="main-content">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/funcionalidades" element={<Features />} />
          <Route path="/software-para-distribuidoras" element={<SoftwareForDistributorsLanding />} />
          <Route path="/controle-financeiro-empresarial" element={<FinancialControlLanding />} />
          <Route path="/controle-de-estoque" element={<StockControlLanding />} />
          <Route path="/webinar-dre" element={<WebinarDreLanding />} />
          <Route path="/webinar-dre/gravacao" element={<Gravacao />} />
          <Route path="/diagnostico" element={<Diagnostico />} />
          <Route path="/descadastro" element={<Descadastro />} />

          {/* Landing pages de SEO por intenção de busca */}
          <Route path="/sistema-de-ordem-de-servico" element={<ServiceOrderLanding />} />
          <Route path="/sistema-de-pdv" element={<PDVLanding />} />
          <Route path="/sistema-de-controle-de-compras" element={<PurchaseControlLanding />} />
          <Route path="/sistema-de-gestao-de-vendas" element={<SalesManagementLanding />} />
          <Route path="/sistema-de-comissao-de-vendedores" element={<SellerCommissionLanding />} />
          <Route path="/sistema-de-orcamentos" element={<ProposalsLanding />} />
          <Route path="/catalogo-de-produtos-online" element={<PublicCatalogLanding />} />
          <Route path="/sistema-com-portal-do-cliente" element={<CustomerPortalLanding />} />
          <Route path="/emissor-de-nfe" element={<NFeIssuerLanding />} />
          <Route path="/emissor-de-nfse" element={<NFSeIssuerLanding />} />
          <Route path="/sistema-de-cobranca-automatica" element={<AutomaticBillingLanding />} />
          <Route path="/sistema-de-fluxo-de-caixa" element={<CashFlowLanding />} />
          <Route path="/controle-de-frota-de-veiculos" element={<VehicleFleetLanding />} />
          <Route path="/controle-de-manutencao-de-equipamentos" element={<EquipmentMaintenanceLanding />} />
          <Route path="/sistema-de-gestao-de-contratos" element={<ContractManagementLanding />} />
          <Route path="/sistema-para-oficina-mecanica" element={<MechanicWorkshopLanding />} />
          <Route path="/sistema-para-prestadores-de-servico" element={<ServiceProvidersLanding />} />
          <Route path="/sistema-para-construtora" element={<ConstructionLanding />} />
          <Route path="/sistema-para-transportadora" element={<TransportationLanding />} />
          <Route path="/sistema-para-locadora-de-equipamentos" element={<EquipmentRentalLanding />} />
          <Route path="/sistema-para-assistencia-tecnica" element={<TechnicalAssistanceLanding />} />
          <Route path="/sistema-para-representante-comercial" element={<SalesRepLanding />} />
          <Route path="/sistema-multiempresa" element={<MultiCompanyLanding />} />
          <Route path="/sistema-para-forca-de-vendas" element={<SalesForceLanding />} />
          <Route path="/sistema-para-lojas" element={<RetailStoreLanding />} />
          <Route path="/erp-customizado" element={<CustomERPLanding />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
};

export default App;
